import { createContext, use, useCallback, useState } from 'react'
import { Icon, Popover } from '@kenect-ut/kenect-ui-kit'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import './Dropdown.scss'

const DropdownCloseContext = createContext(() => {})
export const useDropdownClose = () => use(DropdownCloseContext)

function Dropdown({ title, value, className, children, onClose }) {
  const [isOpen, setIsOpen] = useState(false)
  const iconClassName = classNames('dropdownCarat', isOpen && 'rotateCarat')
  const wrapperClassName = classNames(className, 'dropdownWrapper')

  const handleClose = useCallback(() => {
    setIsOpen(false)
    onClose?.()
  }, [onClose])
  const handleOpen = () => setIsOpen(true)
  const handleOpenChange = (open) => (open ? handleOpen() : handleClose())
  const handleToggle = () => (isOpen ? handleClose() : handleOpen())

  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={handleOpenChange}
      placement="bottom-end"
      noPadding
      content={
        <DropdownCloseContext value={handleClose}>
          {children}
        </DropdownCloseContext>
      }
    >
      <button type="button" onClick={handleToggle} className={wrapperClassName}>
        <div>
          <div className="dropdownTitle">{title}</div>
          <div className="dropdownValue">{value}</div>
        </div>
        <div className="iconContainer">
          <Icon className={iconClassName} name="carat-solid" />
        </div>
      </button>
    </Popover>
  )
}

Dropdown.propTypes = {
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  value: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf([PropTypes.node]),
  ]).isRequired,
  className: PropTypes.string,
  onClose: PropTypes.func,
}

export default Dropdown
